import React from "react";
import { Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import createStore from "../store"; // Import Redux store
import NotFound from "../internal/components/404page";
import { DemoRatesPage } from "./ratesAndQuotes/DemoRatesPage";
import { DemoQuotesPage } from "./ratesAndQuotes/DemoQuotesPage";

// Import Internal Components
const { store } = createStore();

const DemoRoutes: React.FC = () => {
  return (
    <Provider store={store}>
      <Routes>
        <Route path="rates" element={<DemoRatesPage />} />
        <Route path="quotes" element={<DemoQuotesPage />} />
      </Routes>
    </Provider>
  );
};

export default DemoRoutes;
